import { faAdd, faMinus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Box, HStack, Input, Pressable } from 'native-base';
import React from 'react';
import { SpIcon } from '~/shared/Icon';
import { useShopStyles } from '~/shared/styles';

type QuantityPickerProp = {
    quantity: number;
    maxQuantity: number;
    setQuantity: (value: number) => void;
    isLoading: boolean;
    isNullable?: boolean;
    variant: 'small' | 'large';
};

export const QuantityPicker = ({
    quantity,
    maxQuantity,
    setQuantity,
    isLoading,
    isNullable = true,
    variant,
}: QuantityPickerProp) => {

    const { icon, button_background, section_background, input_background } = useShopStyles();
    const lowestBound = isNullable ? 0 : 1;
    const isRemoveDisabled = isLoading || quantity <= lowestBound;
    const isAddDisabled = isLoading || quantity >= maxQuantity;

    const onChangeValue = (value) => {

        const intValue = parseInt(value.slice(0, 3));
        if (intValue) {
            setQuantity(intValue);
        }
    };

    const onBlur = () => {

        if (isNaN(quantity) || typeof quantity !== 'number' || quantity < lowestBound) {
            setQuantity(lowestBound);
        }

        if (quantity > maxQuantity) {
            setQuantity(maxQuantity);
        }
    };

    return ( variant === 'small' ?
        <HStack alignItems={'center'} alignSelf={'center'}>
            <Pressable
                disabled={isRemoveDisabled}
                onPress={() => setQuantity(quantity - 1)}
            >
                <Box
                    w={'40px'}
                    h={'30px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    background={section_background}
                    borderColor={button_background}
                    borderLeftRadius={5}
                    borderWidth={1}
                    opacity={isRemoveDisabled ? .5 : 1}
                >
                    <SpIcon icon={quantity === 1 && isNullable ? faTrash : faMinus} color={icon} size={14} />
                </Box>
            </Pressable>
            <Input
                w={'40px'}
                h={'30px'}
                p={0}
                borderRadius={0}
                textAlign={'center'}
                isDisabled={isLoading}
                value={quantity.toString()}
                onChangeText={onChangeValue}
                onBlur={onBlur}
            />
            <Pressable
                disabled={isAddDisabled}
                onPress={() => setQuantity(quantity + 1)}
            >
                <Box
                    w={'40px'}
                    h={'30px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    background={section_background}
                    borderColor={button_background}
                    borderRightRadius={5}
                    borderWidth={1}
                    opacity={isAddDisabled ? .5 : 1}
                >
                    <SpIcon icon={faAdd} color={icon} size={14} />
                </Box>
            </Pressable>
        </HStack>
        :
        <HStack alignItems={'center'} space={4} alignSelf={'center'}>
            <Pressable
                disabled={isRemoveDisabled}
                onPress={() => setQuantity(quantity - 1)}
            >
                <Box
                    w={'40px'}
                    h={'40px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    borderWidth={1}
                    borderColor={button_background}
                    bg={section_background}
                    borderRadius={'3xl'}
                    opacity={isRemoveDisabled ? .5 : 1}
                >
                    <SpIcon icon={quantity === 1 && isNullable ? faTrash : faMinus} color={icon} size={14} />
                </Box>
            </Pressable>
            <Input
                w={'40px'}
                h={'40px'}
                p={0}
                borderRadius={'lg'}
                borderColor={button_background}
                bg={input_background}
                textAlign={'center'}
                isDisabled={isLoading}
                value={quantity.toString()}
                onChangeText={onChangeValue}
                onBlur={onBlur}
            />
            <Pressable
                disabled={isAddDisabled}
                onPress={() => setQuantity(quantity + 1)}
            >
                <Box
                    w={'40px'}
                    h={'40px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    borderWidth={1}
                    borderColor={button_background}
                    bg={section_background}
                    borderRadius={'3xl'}
                    opacity={isAddDisabled ? .5 : 1}
                >
                    <SpIcon icon={faAdd} color={icon} size={14} />
                </Box>
            </Pressable>
        </HStack>
    );
};
